// extracted by mini-css-extract-plugin
export var cancelButton = "_nu-5";
export var content = "_nu-3";
export var createButton = "_nu-6";
export var drawerContainer = "_nu-0";
export var footer = "_nu-2";
export var header = "_nu-1";
export var orderFormColumn = "_nu-4";